<form class="lp-password-reset-form" [formRoot]="resetPasswordForm">
  @if (initialPasswordMode()) {
    <h1
      i18n="@@auth.passwordReset.initialTitel"
      class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold"
    >
      Initiales Passwort ändern
    </h1>
    @if (isForAdmin()) {
      <p i18n="@@auth.passwordReset.initialAnleitungDu" class="dm-text-md dm-margin-bottom-32">
        Wähle ein neues persönliches Passwort – das initiale Passwort vom Administrator gilt nur für deinen ersten Login.
      </p>
    } @else {
      <p i18n="@@auth.passwordReset.initialAnleitungSie" class="dm-text-md dm-margin-bottom-32">
        Bitte wählen Sie ein neues persönliches Passwort – das initiale Passwort vom Administrator ist nur für den ersten Login gültig.
      </p>
    }
  } @else if (isForced()) {
    <h1
      i18n="@@auth.passwordReset.abgelaufenTitel"
      class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold"
    >
      Bitte Passwort ändern
    </h1>
    <p i18n="@@auth.passwordReset.abgelaufenAnleitung" class="dm-text-md dm-margin-bottom-32">
      Bitte ein neues persönliches Passwort wählen – das Passwort muss einmal pro Jahr geändert werden.
    </p>
  } @else {
    <h1 i18n="@@auth.passwordReset.titel" class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold">
      Neues Passwort setzen
    </h1>
    <p i18n="@@auth.passwordReset.anleitung" class="dm-text-md dm-margin-bottom-32">
      Das neue Passwort muss sich vom bisherigen unterscheiden.
    </p>
  }

  <lp-form-alert [message]="formErrorMessage()" />

  <dm-input
    inputtype="password"
    i18n-label="@@auth.passwordReset.neuesPasswort"
    label="Neues Passwort"
    autocomplete="new-password"
    i18n-placeholder="@@auth.passwordReset.neuesPasswortPlatzhalter"
    placeholder="Neues Passwort eingeben"
    i18n-showPasswordLabel="@@common.input.passwortAnzeigen"
    showPasswordLabel="Passwort anzeigen"
    i18n-hidePasswordLabel="@@common.input.passwortVerbergen"
    hidePasswordLabel="Passwort verbergen"
    [formField]="resetPasswordForm.password"
    [errormsg]="passwordErrorMessage()"
  />

  <div class="dm-margin-top-20">
    <dm-input
      name="confirmPassword"
      inputtype="password"
      i18n-label="@@auth.passwordReset.passwortBestaetigen"
      label="Passwort bestätigen"
      autocomplete="new-password"
      i18n-placeholder="@@auth.passwordReset.passwortBestaetigen"
      placeholder="Passwort bestätigen"
      i18n-showPasswordLabel="@@common.input.passwortAnzeigen"
      showPasswordLabel="Passwort anzeigen"
      i18n-hidePasswordLabel="@@common.input.passwortVerbergen"
      hidePasswordLabel="Passwort verbergen"
      [(value)]="confirmPassword"
      [errormsg]="confirmPasswordErrorMessage()"
    />
  </div>

  <div class="dm-margin-top-24">
    <dm-bullet-list>
      <dm-bullet-item i18n="@@auth.passwordReset.regelLaenge" [color]="passwordPolicy().hasValidLength ? 'success' : 'primary'"
        >Muss mindestens 8 Zeichen lang sein
      </dm-bullet-item>
      <dm-bullet-item i18n="@@auth.passwordReset.regelGrossKlein" [color]="passwordPolicy().hasUpperAndLowerCase ? 'success' : 'primary'"
        >Muss Gross- und Kleinbuchstaben enthalten
      </dm-bullet-item>
      <dm-bullet-item i18n="@@auth.passwordReset.regelZahl" [color]="passwordPolicy().hasDigit ? 'success' : 'primary'"
        >Muss mindestens eine Zahl enthalten
      </dm-bullet-item>
      <dm-bullet-item i18n="@@auth.passwordReset.regelSonderzeichen" [color]="passwordPolicy().hasSpecialChar ? 'success' : 'primary'"
        >Muss mindestens ein Sonderzeichen enthalten
      </dm-bullet-item>
    </dm-bullet-list>
  </div>

  <div class="dm-margin-top-24">
    <dm-button
      [dmType]="'submit'"
      [isLoading]="loadingStatus() === 'loading'"
      [grow]="true"
      [disabled]="resetPasswordForm().invalid() || !isFormValid()"
    >
      @if (initialPasswordMode()) {
        <span i18n="@@auth.passwordReset.aendern">Passwort ändern</span>
      } @else {
        <span i18n="@@auth.passwordReset.zuruecksetzen">Passwort zurücksetzen</span>
      }
    </dm-button>
  </div>

  @if (!initialPasswordMode()) {
    <div class="dm-margin-top-32">
      <p i18n="@@auth.zurueckZumLogin" class="dm-text-sm dm-text-align-center"><a [routerLink]="loginRoute">Zurück zum Login</a></p>
    </div>
  }
</form>
